import { formTypes } from '../../../form/form.constants';
import { ComplianceForm } from './compliance-form.model';
import {YearsInSpreadsheet} from '../../../entertainment/models/digital/yearsInSpreadsheet.model';
import {ApprAsset} from './appr-asset.model';
import {ProjectForm} from '../../../project/models/form.model';

export class ApprExtensionRequest extends ProjectForm {
  year: string;


  requestApprExtension?: boolean;
  understandNewFilingDate?: boolean;


  constructor(formIndex: number = null) {
    super(formIndex);
    this.init();
  }

  init() {
    super.init();
    this.type = formTypes.apprExt.abbrev;
  }

  get qualifier() {
    return '';
  }
}
